/**
 * Push Notification Stats Cards Component
 * Displays key metrics: Active Subscribers, Sent (7 days), Delivery Rate, Web Push vs Polling
 */
import { Bell, Send, TrendingUp, Zap, Radio } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function PushStatsCards({ stats }) {
  if (!stats) return null;

  const cards = [
    {
      title: 'Active Subscribers',
      value: stats.active_subscriptions || 0,
      icon: Bell,
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      title: 'Sent (7 days)',
      value: stats.sent_7_days || 0,
      icon: Send,
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      title: 'Delivery Rate',
      value: `${stats.delivery_rate || 0}%`,
      icon: TrendingUp,
      color: 'text-amber-500',
      bgColor: 'bg-amber-500/10'
    },
    {
      title: 'Web Push',
      value: stats.by_method?.webpush || 0,
      subtitle: `Polling: ${stats.by_method?.polling || 0}`,
      icon: Zap,
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {cards.map((card, idx) => (
        <Card key={card.title} className="border-border" data-testid={`push-stat-${idx}`}>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${card.bgColor}`}>
                <card.icon className={`w-5 h-5 ${card.color}`} />
              </div>
              <div>
                <p className="text-xs text-muted-foreground">{card.title}</p>
                <p className="text-xl font-bold text-foreground">{card.value}</p>
                {card.subtitle && (
                  <p className="text-xs text-muted-foreground">{card.subtitle}</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
